import styled from 'styled-components';
import fn from '../../helpers/fn';
import theme from '../theme';

export default fn(__filename, styled.button`
  color: ${theme.colors.gray4};
  line-height: initial;
  display: inline-block;
  text-decoration: none;
  font-weight: 600;
  appearance: none;
  border: 0;
  background: none;
  font-size: inherit;
  font-family: inherit;
  border-radius: 0;
  padding: 0;
  line-height: 1.5;
  outline: 0;

  ${({ right }) => right && `
    float: right;
  `}
`);



// WEBPACK FOOTER //
// ./src/components/links/LinkButton.js